var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanprocess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.642,
    height: 71.126,
    viewBox: "0 0 71.642 71.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plan_process",
    "data-name": "plan process",
    transform: "translate(-1116.386 -5316.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21925",
    "data-name": "Path 21925",
    d: "M30.26,10.995c3.413-26.869,30.26,1.884,30.26,18.6A30.26,30.26,0,0,1,0,29.591C0,12.878,26.847,37.863,30.26,10.995Z",
    transform: "matrix(0.978, -0.208, 0.208, 0.978, 1116.386, 5329.4)",
    fill: "#bcfbff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17218",
    "data-name": "Group 17218"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6831",
    "data-name": "Rectangle 6831",
    width: 4.061,
    height: 4.061,
    rx: 2.03,
    transform: "translate(1135.631 5342.139)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6832",
    "data-name": "Rectangle 6832",
    width: 4.061,
    height: 4.061,
    rx: 2.03,
    transform: "translate(1135.631 5350.26)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7176",
    "data-name": "Path 7176",
    d: "M335.525,277.673l2.147-2.147,4.766,4.767-2.147,2.147Z",
    transform: "translate(825.646 5078.617)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7177",
    "data-name": "Path 7177",
    d: "M385.043,325.043a2.429,2.429,0,0,1-3.435,0l-6.055-6.055a.3.3,0,0,1,0-.43l3.006-3.006a.3.3,0,0,1,.429,0l6.055,6.055A2.429,2.429,0,0,1,385.043,325.043Z",
    transform: "translate(789.311 5042.283)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 9.77,
    cy: 9.77,
    rx: 9.77,
    ry: 9.77,
    transform: "translate(1147.932 5340.903)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6833",
    "data-name": "Rectangle 6833",
    width: 4.061,
    height: 4.061,
    rx: 2.03,
    transform: "translate(1135.631 5358.382)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6834",
    "data-name": "Rectangle 6834",
    width: 4.061,
    height: 4.061,
    rx: 2.03,
    transform: "translate(1135.631 5366.502)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7178",
    "data-name": "Path 7178",
    d: "M320.525,277.673l2.147-2.147,4.766,4.767-2.147,2.147Z",
    transform: "translate(839.292 5078.617)",
    fill: "#595f74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7179",
    "data-name": "Path 7179",
    d: "M337.5,275.526l-.677.677,2.308,2.308a1.721,1.721,0,0,1,0,2.434l-.253.254,1.242,1.242,2.147-2.147Z",
    transform: "translate(824.469 5078.617)",
    fill: "#4a4f60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7180",
    "data-name": "Path 7180",
    d: "M370.043,325.043a2.429,2.429,0,0,1-3.435,0l-6.055-6.055a.3.3,0,0,1,0-.429l3.006-3.006a.3.3,0,0,1,.43,0l6.055,6.055A2.429,2.429,0,0,1,370.043,325.043Z",
    transform: "translate(802.957 5042.283)",
    fill: "#f7901f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7181",
    "data-name": "Path 7181",
    d: "M396.586,321.608l-6.055-6.055a.3.3,0,0,0-.429,0l-.462.462,5.593,5.593a2.429,2.429,0,0,1-1.041,4.051,2.429,2.429,0,0,0,2.394-4.051Z",
    transform: "translate(776.414 5042.283)",
    fill: "#ffc166"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 9.77,
    cy: 9.77,
    rx: 9.77,
    ry: 9.77,
    transform: "translate(1146.578 5340.903)",
    fill: "#f7901f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7182",
    "data-name": "Path 7182",
    d: "M282.167,131.667a9.747,9.747,0,0,0-7.585-2.838,9.77,9.77,0,0,1,0,19.493,9.77,9.77,0,0,0,7.585-16.655Z",
    transform: "translate(881.09 5212.098)",
    fill: "#f7901f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7183",
    "data-name": "Path 7183",
    d: "M215.67,170.673a7.084,7.084,0,1,1,0-10.018A7.084,7.084,0,0,1,215.67,170.673Z",
    transform: "translate(945.687 5185.009)",
    fill: "#d9f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7184",
    "data-name": "Path 7184",
    d: "M5.369,33.84h2.8a1.31,1.31,0,0,0,1.308-1.308v-2.8a1.31,1.31,0,0,0-1.308-1.308h-2.8a1.31,1.31,0,0,0-1.308,1.308v2.8A1.31,1.31,0,0,0,5.369,33.84Zm.045-4.061H8.122v2.707H5.414Zm20.04-.627a7.757,7.757,0,1,0-5.488-2.27A7.757,7.757,0,0,0,25.455,29.151Zm-.076-8.171H19.065a6.4,6.4,0,0,1,.795-2.707h5.519a.677.677,0,0,0,0-1.354H20.87l.054-.057a6.407,6.407,0,1,1,9.062,9.062h0A6.4,6.4,0,0,1,19.12,22.334h6.259a.677.677,0,0,0,0-1.354ZM10.344,4.235a.677.677,0,1,0,.677.677A.677.677,0,0,0,10.344,4.235Zm2.03,18.776a.677.677,0,0,0,.677.677h2.215a10.453,10.453,0,0,0,15.859,6.481l.966.966a.981.981,0,0,0,.047,1.335l6.055,6.055a3.106,3.106,0,0,0,4.392-4.392l-6.055-6.055a.981.981,0,0,0-1.335-.047l-.966-.966A10.447,10.447,0,0,0,18.068,14.007q-.1.1-.2.206H13.051a.677.677,0,1,0,0,1.354h3.733a10.454,10.454,0,0,0-1.729,6.768h-2a.677.677,0,0,0-.677.677Zm23.3,6.454h0l.165-.165,5.791,5.791a1.752,1.752,0,0,1-2.478,2.478l-5.791-5.791Zm-1.435-.479-1.19,1.19-.823-.823q.318-.271.619-.571t.571-.619ZM19.025,14.964a9.065,9.065,0,1,1-2.675,6.43,9.094,9.094,0,0,1,2.675-6.43ZM42.818,0H3.384A3.388,3.388,0,0,0,0,3.384V42.818A3.388,3.388,0,0,0,3.384,46.2H42.818A3.388,3.388,0,0,0,46.2,42.818V3.384A3.388,3.388,0,0,0,42.818,0Zm2.03,42.818a2.033,2.033,0,0,1-2.03,2.03H3.384a2.033,2.033,0,0,1-2.03-2.03V9.475h43.5Zm0-34.7H1.354V3.384a2.033,2.033,0,0,1,2.03-2.03H42.818a2.033,2.033,0,0,1,2.03,2.03ZM7.637,4.235a.677.677,0,1,0,.677.677.677.677,0,0,0-.677-.677ZM5.369,25.718h2.8A1.31,1.31,0,0,0,9.475,24.41v-2.8A1.31,1.31,0,0,0,8.167,20.3h-2.8a1.31,1.31,0,0,0-1.308,1.308v2.8a1.31,1.31,0,0,0,1.308,1.308Zm.045-4.061H8.122v2.707H5.414Zm-.045,20.3h2.8a1.31,1.31,0,0,0,1.308-1.308v-2.8a1.31,1.31,0,0,0-1.308-1.308h-2.8a1.31,1.31,0,0,0-1.308,1.308v2.8a1.31,1.31,0,0,0,1.308,1.308ZM5.414,37.9H8.122v2.707H5.414ZM5.369,17.6h2.8a1.31,1.31,0,0,0,1.308-1.308v-2.8a1.31,1.31,0,0,0-1.308-1.308h-2.8a1.31,1.31,0,0,0-1.308,1.308v2.8A1.31,1.31,0,0,0,5.369,17.6Zm.045-4.061H8.122v2.707H5.414Zm7.637,26.395h23a.677.677,0,0,0,0-1.354h-23a.677.677,0,0,0,0,1.354ZM4.929,4.235a.677.677,0,1,0,.677.677A.677.677,0,0,0,4.929,4.235Zm8.122,27.575h4.206a.677.677,0,1,0,0-1.354H13.051a.677.677,0,1,0,0,1.354Z",
    transform: "translate(1130.894 5329.279)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanprocess);
export default __webpack_public_path__ + "static/media/planprocess.c1d5dfd8aac74905eedc013613a8b55d.svg";
export { ForwardRef as ReactComponent };